import SmoothScroll from 'smooth-scroll'
/**
 * GlobalHeader functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalHeader {
  /**
   * Constructs a new GlobalHeader instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.globalFooter = document.querySelector('[data-component="global-footer"]')
    this.navToggle = this.element.querySelector('[data-component="nav-toggle"]')
    this.mainNav = this.element.querySelector('[data-component="main-nav"]')
    this.contactNavItem = this.element.querySelector('[data-component="main-nav"] li.contact')
    this.scroll = new SmoothScroll()
    this.scrollOptions = {
      speed: 500,
      speedAsDuration: true,
      updateURL: false
    }

    this.navToggle.addEventListener('click', () => {
      this.element.classList.toggle('nav-open')
      this.navToggle.classList.toggle('is-active')
      document.body.classList.toggle('nav-open')
    })

    this.contactNavItem.addEventListener('click',  (e) => {
      e.preventDefault()
      if (this.element.classList.contains('nav-open')) {
        this.element.classList.remove('nav-open')
        this.navToggle.classList.remove('is-active')
        document.body.classList.remove('nav-open')
      }
      this.scroll.animateScroll(this.globalFooter);
    })

  }
}



// WEBPACK FOOTER //
// ./components/global-header/index.js